import { enumParser } from '#validation/common/parsers';
import { WorkspaceDomainStatus } from '../constants';
export const domainStatusParser = enumParser(WorkspaceDomainStatus);
